import Index from '@/views/exhibitor/dashboard/Index.vue';
import Analytics from '@/views/exhibitor/dashboard/Analytics.vue';
import { auths, actors } from '@/router/options';

const routes: any[] = [
  {
    path: 'dashboard',
    component: Index,
    children: [
      {
        name: 'exhibitor-dashboard-analytics',
        path: '',
        component: Analytics,
        meta: {
          title: 'ダッシュボード',
          actor: actors.exhibitor,
          auth: auths.required,
        },
      },
    ],
  },
];

export default {
  routes,
};
